<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.add_contest") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #7514b7">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- ============= Start:: Contest Details Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_details") }}</h5>
          </div>

          <!-- Start:: Name Input (Arabic) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.contest_name') +
              ' (' +
              $t('PLACEHOLDERS.ar') +
              ')'
            "
            v-model.trim="data.nameAr"
            :maxlength="50"
            required
          />
          <!-- End:: Name Input (Arabic) -->

          <!-- Start:: Name Input (English) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.contest_name') +
              ' (' +
              $t('PLACEHOLDERS.en') +
              ')'
            "
            v-model.trim="data.nameEn"
            :maxlength="50"
            required
          />
          <!-- End:: Name Input (English) -->

          <!-- Start:: Contest Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="contest_image"
            :placeholder="$t('PLACEHOLDERS.contest_image')"
            @selectImage="selectContestImage"
            required
          />
          <!-- End:: Contest Image Upload Input -->

          <!-- ============= Start:: Contest Duration Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_duration") }}</h5>
          </div>

          <!-- Start:: Start Date Input -->

          <base-picker-input
            col="6"
            type="datetime"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.startDate"
            required
          />
          <!-- End:: Start Date Input -->
          <!-- Start:: End Date Input -->
          <base-picker-input
            col="6"
            type="datetime"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.endDate"
            required
          />

          <!-- End:: End Date Input -->

          <!-- ============= Start:: Sponsor Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.sponsor_info") }}</h5>
          </div>

          <!-- Start:: Sponsor Name Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sponsor_name')"
            v-model.trim="data.sponsorName"
          />
          <!-- End:: Sponsor Name Input -->

          <!-- Start:: Sponsor Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="sponsor_image"
            :placeholder="$t('PLACEHOLDERS.sponsor_image')"
            @selectImage="selectSponsorImage"
          />
          <!-- End:: Sponsor Image Upload Input -->

          <!-- ============= Start:: Contest Conditions Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_conditions") }}</h5>
          </div>

          <!-- Start:: Activity Select -->
          <base-select-input
            col="6"
            :optionsList="activities"
            :placeholder="$t('PLACEHOLDERS.activity')"
            v-model="data.activity"
            required
          />
          <!-- End:: Activity Select -->

          <!-- Start:: Condition Type Select -->
          <base-select-input
            col="6"
            :optionsList="conditionTypes"
            :placeholder="$t('PLACEHOLDERS.condition_type')"
            v-model="data.conditionType"
            required
          />
          <!-- End:: Condition Type Select -->

          <!-- Start:: Condition Value Input -->
          <base-input
            col="12"
            type="number"
            :placeholder="$t('PLACEHOLDERS.condition_value')"
            v-model.number="data.conditionValue"
            min="0"
            step="0.01"
            required
          />
          <!-- End:: Condition Value Input -->

          <!-- ============= Start:: Contest Rewards Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_rewards") }}</h5>
          </div>

          <!-- Start:: Prize Type Select -->
          <base-select-input
            col="6"
            :optionsList="prizeTypes"
            :placeholder="$t('PLACEHOLDERS.prize_type')"
            v-model="data.prizeType"
            required
          />
          <!-- End:: Prize Type Select -->

          <!-- Start:: Prize Value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.prize_value')"
            v-model.number="data.prizeValue"
            min="0"
            step="0.01"
            required
          />
          <!-- End:: Prize Value Input -->

          <!-- ============= Start:: Contest Type Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.contest_type") }}</h5>
          </div>

          <!-- Start:: Contest Type Select -->
          <base-select-input
            col="12"
            :optionsList="contestTypes"
            :placeholder="$t('PLACEHOLDERS.contest_type')"
            v-model="data.contestType"
            required
          />
          <!-- End:: Contest Type Select -->

          <!-- Start:: Fees Input (Conditional) -->
          <base-input
            v-if="data.contestType && data.contestType.value === 'paid'"
            col="12"
            type="number"
            :placeholder="$t('PLACEHOLDERS.contest_fees')"
            v-model.number="data.fees"
            min="0"
            step="0.01"
            required
          />
          <!-- End:: Fees Input (Conditional) -->

          <!-- ============= Start:: Additional Info Section ============= -->
          <div class="col-12">
            <h5 class="my-3">{{ $t("PLACEHOLDERS.additional_info") }}</h5>
          </div>

          <!-- Start:: Description Input  -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model="data.descriptionAr"
            :maxLength="500"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model="data.descriptionEn"
            :maxLength="500"
            required
          />
          <!-- End:: Description Input  -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-12">
            <v-switch
              color="green"
              :label="
                data.isActive
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.isActive"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "CreateContest",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        contestImage: {
          path: null,
          file: null,
        },
        sponsorImage: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        startDate: null,
        endDate: null,
        sponsorName: null,
        activity: null,
        conditionType: null,
        conditionValue: null,
        prizeType: null,
        prizeValue: null,
        contestType: null,
        fees: null,
        descriptionAr: null,
        descriptionEn: null,
        isActive: true,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Activities List
    activities() {
      return [
        { id: 1, name: this.$t("ACTIVITIES.walking_running"), value: 1 },
        { id: 2, name: this.$t("ACTIVITIES.cycling"), value: 2 },
        { id: 3, name: this.$t("ACTIVITIES.horse_riding"), value: 3 },
      ];
    },

    // Condition Types List
    conditionTypes() {
      return [
        {
          id: 1,
          name: this.$t("CONDITION_TYPES.steps"),
          value: "steps",
        },
        {
          id: 2,
          name: this.$t("CONDITION_TYPES.distance"),
          value: "distance",
        },
      ];
    },

    // Prize Types List
    prizeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PRIZE_TYPES.points"),
          value: "points",
        },
        {
          id: 2,
          name: this.$t("PRIZE_TYPES.money"),
          value: "money",
        },
      ];
    },

    // Contest Types List
    contestTypes() {
      return [
        {
          id: 1,
          name: this.$t("CONTEST_TYPE.automatic"),
          value: "automatic",
        },
        {
          id: 2,
          name: this.$t("CONTEST_TYPE.free"),
          value: "free",
        },
        {
          id: 3,
          name: this.$t("CONTEST_TYPE.paid"),
          value: "paid",
        },
      ];
    },
  },

  methods: {
    selectContestImage(selectedImage) {
      this.data.contestImage = selectedImage;
    },

    selectSponsorImage(selectedImage) {
      this.data.sponsorImage = selectedImage;
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      // Validate dates
      if (this.data.startDate && this.data.endDate) {
        const startDate = new Date(this.data.startDate);
        const endDate = new Date(this.data.endDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (startDate < today) {
          this.$message.error(this.$t("MESSAGES.startDateMustBeFuture"));
          return;
        }

        if (endDate <= startDate) {
          this.$message.error(this.$t("MESSAGES.endDateMustBeAfterStart"));
          return;
        }
      }

      // Validate fees for paid contests
      if (
        this.data.contestType &&
        this.data.contestType.value === "paid" &&
        !this.data.fees
      ) {
        this.$message.error(this.$t("MESSAGES.feesRequired"));
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      if (this.data.nameAr) {
        REQUEST_DATA.append("name[ar]", this.data.nameAr);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.contestImage.file) {
        REQUEST_DATA.append("contest_image", this.data.contestImage.file);
      }
      if (this.data.sponsorImage.file) {
        REQUEST_DATA.append("sponsor_image", this.data.sponsorImage.file);
      }
      if (this.data.startDate) {
        REQUEST_DATA.append("start_date", this.data.startDate);
      }
      if (this.data.endDate) {
        REQUEST_DATA.append("end_date", this.data.endDate);
      }
      if (this.data.sponsorName) {
        REQUEST_DATA.append("sponsor_name", this.data.sponsorName);
      }
      if (this.data.activity) {
        REQUEST_DATA.append("activity_id", this.data.activity.value);
      }
      if (this.data.conditionType) {
        REQUEST_DATA.append("condition", this.data.conditionType.value);
      }
      if (this.data.conditionValue) {
        REQUEST_DATA.append("condition_value", this.data.conditionValue);
      }
      if (this.data.prizeType) {
        REQUEST_DATA.append("prize", this.data.prizeType.value);
      }
      if (this.data.prizeValue) {
        REQUEST_DATA.append("prize_value", this.data.prizeValue);
      }
      if (this.data.contestType) {
        REQUEST_DATA.append("type", this.data.contestType.value);
      }
      if (this.data.fees && this.data.contestType?.value === "paid") {
        REQUEST_DATA.append("fees", this.data.fees);
      }
      if (this.data.descriptionAr) {
        REQUEST_DATA.append("description[ar]", this.data.descriptionAr);
      }
      if (this.data.descriptionEn) {
        REQUEST_DATA.append("description[en]", this.data.descriptionEn);
      }

      REQUEST_DATA.append("is_active", this.data.isActive ? 1 : 0);
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `contests`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/contests/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    // End:: Fire Methods
  },
};
</script>
